import React, { useState, useEffect } from 'react'
import expand_icon from '../assets/expand.svg'
import { Collapse } from 'antd';
import contract from '../assets/contract.svg'
import ForecastDropDown from './ForecastDropDown';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';


const { Panel } = Collapse;
function ContractDropDown({ genExtra, setName, setValue, setMainID, expanded, entry, expenseFormatted, budgetFormatted, contracted, forecasted, spent }) {
    /*const expandAll = () => {
        console.log(Array.from(Array(2).keys()))
        setExpandedPanels((prev) =>{
            if(prev.length ==1){
                return ['0', '1']
            }else{
                return ['0']
            }
        });}*/
    const [expand, setExpand] = useState(['0', '1']);
    useEffect(() => {
        if (expanded) {
            setExpand(['0', '1'])
        } else {
            setExpand(['0'])
        }
    }, [expanded])
    const onPanelChange = (panelKey) => {
        console.log(panelKey)
        setExpand(panelKey);
    };

    return (
        <div className={entry.MainBudgetLineID === 'Unlinked' ? 'disabled' : 'contract'}>
            <Collapse
                expandIconPosition='end'
                size='large'
                activeKey={expand}
                onChange={onPanelChange}
                expandIcon={({ isActive }) => <img className={isActive ? 'expanded' : 'expand'} src={expand_icon} alt='#' />}
            >
                <Panel
                    header={<>
                        <div className='contract-name' >
                            <img src={contract} alt='#' />
                            &nbsp;
                            <span style={{ position: 'absolute', top: '-3px', left: '25px', width: '400px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{entry.MainBudgetLineName}</span>
                        </div>
                            <div className='contract-value'>
                                <Tooltip title="Actuals (Actuals % Forecasted)" placement="bottom">
                                    <span>
                                        {/* actuals || actuals % forecasted */}
                                        {Math.round(spent).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                        <span style={{ fontWeight: 100 }} >
                                            &nbsp;
                                            {forecasted ? '(' + Math.round(spent ? spent / forecasted * 100 : 0) + '%)' : ''}
                                        </span>
                                    </span>
                                </Tooltip>
                                &nbsp;|&nbsp;
                                <Tooltip title="Forecasted (Forecasted % Contracted)" placement="bottom">
                                    <span>
                                        {/* forcasted || forecasted % contracted */}
                                        {Math.round(forecasted).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                        <span style={{ fontWeight: 100 }} >
                                            &nbsp;
                                            {contracted ? '(' + Math.round(forecasted ? forecasted / contracted * 100 : 0) + '%)' : ''}
                                        </span>
                                    </span>
                                </Tooltip>
                                &nbsp;|&nbsp;
                                <Tooltip title="Contracted" placement="bottom">
                                    <span>
                                        {/* contracted */}
                                        {Math.round(contracted).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </span>
                                </Tooltip>
                            </div>
                    </>}
                    key="1"
                    extra={entry.MainBudgetLineID !== 'Unlinked' ? genExtra(entry, false) : ''}
                >
                    {budgetFormatted[entry.MainBudgetLineID + ''].map((entry, index) => {
                        return <ForecastDropDown
                            parent={entry.MainBudgetLineID}
                            entry={entry}
                            expenseFormatted={expenseFormatted}
                            budgetFormatted={budgetFormatted}
                            genExtra={genExtra}
                            contracted={contracted}
                            forecasted={entry.Value}
                            spent={expenseFormatted[entry.BudgetLineID + ''].reduce((a, b) => a + (b['Input'] || 0), 0)}
                            expanded={expanded}
                        />
                    })}
                </Panel>
            </Collapse>
        </div>
    )
}

export default ContractDropDown